"use client";

import React from "react";
import Image from "next/image";

const QualityEngagement: React.FC = () => {
  return (
    <section className="w-full bg-white pb-15 px-4 lg:px-8">
      <div className="max-w-[1145.76px] mx-auto">
        {/* Header Section */}
        <div className="max-w-202.75 mx-auto text-center">
          <h2 className="text-[30px] md:text-[40px] leading-10 md:leading-13.25 font-light text-[#1B365E] mb-5">
            Engagement de qualité chez Spot Formations
          </h2>
          <p className="text-[#1D1D1D] text-base leading-6.5">
            Le processus d&apos;amélioration continue est mise en place tout au
            long de notre méthode, il commence avant de s&apos;engager dans une
            formation, avec notre Quiz d&apos;orientation et d&apos;évaluation,
            et il continue après la formation dans la phase de Coaching, avec un
            suivi et une gestion des retours de nos apprenants.
          </p>
        </div>

        {/* Process Section */}
        <div className="mt-5">
          <h3 className="text-center text-3xl leading-10 font-light text-[#1B365E]">
            Notre processus d&apos;amélioration continue en 3 étapes
          </h3>

          {/* Circular Process Diagram */}
          <div className="relative w-54.5 mx-auto shrink-0 flex items-center justify-center mb-12 mt-14.25">
            {/* SVG Circle with arrows */}
            <Image
              className="w-54.5 shrink-0"
              src="/assets/circle.svg"
              alt="Circle"
              title="Circle"
              width={218}
              height={218}
            />

            {/* Process nodes */}
            <div className="absolute inset-0 flex items-center justify-center">
              {/* Center Icon */}
              <div className="absolute w-[57.65px] shrink-0">
                <Image
                  src="/assets/icons/verification.svg"
                  alt="Verification"
                  title="Verification"
                  width={57.65}
                  height={63.3}
                />
              </div>

              {/* Step 1 - Top Left */}
              <div className="absolute md:-top-4 -top-12 md:-left-41.5 -left-1 flex md:flex-row flex-col items-center md:gap-3.5 gap-1.5">
                <p className="md:text-right text-center md:text-[20px] text-xs md:leading-7.5 leading-3.5 text-[#1B365E] md:font-medium font-bold">
                  Recueil <br /> des appréciations
                </p>
                <div className="w-17.25 h-17.25 bg-[#C7F8FF] rounded-full border-r border-b border-t-0 border-l-0 border-[#D9D9D9] flex items-center justify-center text-[#1B365E] font-light text-[40px] leading-13.25 font-red-hat">
                  1
                </div>
              </div>

              {/* Step 2 - Right */}
              <div className="absolute md:-right-55.5 -right-15 md:bottom-[35%] bottom-[16.75%] flex md:flex-row flex-col items-center md:gap-3.5 gap-0.75">
                <div className="w-17.25 h-17.25 bg-[#C7F8FF] rounded-full border-r border-b border-t-0 border-l-0 border-[#D9D9D9] flex items-center justify-center text-[#1B365E] font-light text-[40px] leading-13.25 font-red-hat">
                  2
                </div>
                <div className="md:ms-0 ms-10.75 flex flex-col md:gap-0 gap-0.75 md:text-left text-center">
                  <h6 className="md:text-[20px] text-xs md:leading-7.5 leading-3 md:font-medium font-bold">
                    Suivi
                  </h6>
                  <p className="md:w-auto w-17.75 md:text-right md:text-xs text-[8px] md:leading-5 leading-3 text-[#1B365E]">
                    Cadre de gestion des réclamations
                  </p>
                </div>
              </div>

              {/* Step 3 - Bottom */}
              <div className="absolute md:-bottom-15 -bottom-9 md:left-0.5 left-7.25 flex flex-col items-center md:gap-3.25 gap-2">
                <div className="w-17.25 h-17.25 bg-[#C7F8FF] rounded-full border-r border-b border-t-0 border-l-0 border-[#D9D9D9] flex items-center justify-center text-[#1B365E] font-light text-[40px] leading-13.25 font-red-hat">
                  3
                </div>
                <p className="text-right md:text-[20px] text-xs md:leading-7.5 leading-3 text-[#1B365E] md:font-medium font-bold">
                  Implémentation
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="md:overflow-x-clip overflow-x-scroll md:overflow-y-visible overflow-y-clip md:pb-0 pb-4.5 lg:px-0 px-4">
          {/* Timeline Section */}
          <div className="md:mt-44.25 mt-30 flex items-start relative min-w-[612.98px]">
            <Image
              className="w-[30.26px] shrink-0"
              src="/assets/male.svg"
              alt="Male"
              title="Male"
              width={30.26}
              height={100.3}
            />
            <div className="grow bg-[#C7F8FF] rounded-2xl md:h-auto h-11.75 py-2 px-4 relative flex items-center justify-center">
              <div className="flex gap-10.5 lg:gap-23 xl:gap-28.75 absolute md:-top-12.75 -top-7.5 left-1/2 -translate-x-1/2">
                {["Test", "Parcours", "Formation", "Évaluation", "Suivi"].map(
                  (step, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center gap-0.75"
                    >
                      <span className="text-[#1B365E] text-[18px] md:text-[30px] md:leading-10 leading-5 font-light font-red-hat">
                        {step}
                      </span>
                      <Image
                        className="w-4 shrink-0"
                        src="/assets/icons/point.svg"
                        alt="point"
                        width={16}
                        height={16}
                      />
                    </div>
                  ),
                )}
              </div>
              <div className="text-center flex items-center justify-center lg:gap-4.25 gap-1.75 min-w-[537.22px]">
                <div className="flex">
                  <Image
                    className="-me-1 xl:w-4.25 lg:w-4 w-2.75 shrink-0"
                    src="/assets/icons/arrow-white.svg"
                    alt="Arrow"
                    title="Arrow"
                    width={17}
                    height={30}
                  />
                  <Image
                    className="xl:me-9.5 lg:me-5 md:me-2 me-7 xl:w-4.25 lg:w-4 w-2.75 shrink-0"
                    src="/assets/icons/arrow-white.svg"
                    alt="Arrow"
                    title="Arrow"
                    width={17}
                    height={30}
                  />
                </div>
                <Image
                  className="w-6.5 shrink-0"
                  src="/assets/icons/medal.svg"
                  alt="Medal"
                  title="Medal"
                  width={26}
                  height={26}
                />
                <p className="lg:text-base md:text-sm text-[8px] lg:leading-6.5 md:leading-5 leading-2.5 text-[#1D1D1D]">
                  La qualité de notre méthode est garantie par notre{" "}
                  <span className="font-bold">
                    processus d&apos;amélioration continue
                  </span>
                </p>
                <Image
                  className="xl:ms-15 lg:ms-8 md:ms-2.5 ms-2 xl:w-4.25 lg:w-4 w-2.75 shrink-0"
                  src="/assets/icons/arrow-white.svg"
                  alt="Arrow"
                  title="Arrow"
                  width={17}
                  height={30}
                />
              </div>
            </div>
            <Image
              className="w-11.25 shrink-0"
              src="/assets/female.svg"
              alt="Male"
              title="Male"
              width={45}
              height={97.1}
            />
            <div className="absolute xl:-bottom-4 -bottom-3.25 left-[48.9%] -translate-x-1/2 xl:w-225.25 lg:w-202 md:w-150.5 w-110 h-17.75 bg-[url('/assets/line-arrow.svg')] bg-no-repeat bg-center bg-contain" />
            <div className="absolute xl:-bottom-4 md:-bottom-3.25 bottom-0 left-1/2 -translate-x-1/2 md:py-3 py-[5.96px] md:px-4 px-[7.95px] md:w-18.5 w-[36.78px] min-h-[28.83px] bg-white border-b border-b-[#40BFDE] md:rounded-[40px] rounded-[19.88px] flex items-center justify-center">
              <Image
                className="md:w-10.5 w-[20.88px] min-w-5.25"
                src="/assets/icons/ranking-star.svg"
                alt="evaluation"
                width={42}
                height={34}
              />
            </div>
          </div>
        </div>

        {/* Certification Section */}
        <div className="max-w-[863.9px] mx-auto mt-[89.7px]">
          <h3 className="text-[30px] md:text-[40px] leading-10 md:leading-13.25 font-light text-[#1B365E] mb-5">
            Notre engagement qualité
          </h3>
          <p className="text-[#1D1D1D] text-base leading-6.5">
            Les formations référencées répondent à des exigences claires : des
            objectifs annoncés clairement, des moyens pédagogiques adaptés à
            chaque parcours, une évaluation des acquis en fin de formation et la
            prise en compte de chaque retour d&apos;apprenant dans un processus
            d&apos;amélioration continue.
          </p>
        </div>
      </div>
    </section>
  );
};

export default QualityEngagement;
